/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
import * as i0 from "./recommendation.component.css.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./recommendation.component";
import * as i3 from "@angular/router";
import * as i4 from "../residential.service";
var styles_RecommendationComponent = [i0.styles];
var RenderType_RecommendationComponent = /*@__PURE__*/ i1.ɵcrt({ encapsulation: 0, styles: styles_RecommendationComponent, data: {} });
export { RenderType_RecommendationComponent as RenderType_RecommendationComponent };
export function View_RecommendationComponent_0(_l) { return i1.ɵvid(0, [], null, null); }
export function View_RecommendationComponent_Host_0(_l) {
    return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-recommendation", [], null, [["window", "beforeunload"]], function (_v, en, $event) {
            var ad = true;
            if (("window:beforeunload" === en)) {
                var pd_0 = (i1.ɵnov(_v, 1).beforeunloadHandler($event) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, View_RecommendationComponent_0, RenderType_RecommendationComponent)), i1.ɵdid(1, 114688, null, 0, i2.RecommendationComponent, [i3.Router, i4.ResidentialService], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null);
}
var RecommendationComponentNgFactory = /*@__PURE__*/ i1.ɵccf("app-recommendation", i2.RecommendationComponent, View_RecommendationComponent_Host_0, {}, {}, []);
export { RecommendationComponentNgFactory as RecommendationComponentNgFactory };

